import { render } from "./gameEnd.vue?vue&type=template&id=6cf27cf0"
import script from "./gameEnd.vue?vue&type=script&lang=js"
export * from "./gameEnd.vue?vue&type=script&lang=js"

import "./gameEnd.vue?vue&type=style&index=0&id=6cf27cf0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__